import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import CountUp from "react-countup";

import { useTranslation } from "react-i18next";

function PeopleStatsCard({ people }) {
  const {
    t,
  } = useTranslation();

  return (
    <Card className="card-stats">
      <Card.Body>
        <Row>
          <Col xs="5">
            <div className="icon-big text-center">
              <i className="nc-icon nc-single-02 text-info"></i>
            </div>
          </Col>
          <Col xs="7">
            <div className="numbers">
              <p className="card-category">{t("common.labels.people")}</p>
              <Card.Title as="h4">
                <CountUp start={0} end={people} duration={2} />
              </Card.Title>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default PeopleStatsCard;
